
$(document).ready(function () {

    $("#paytm_phone_to_phone_app_image").hide();	
    $("#phonePe_phone_to_phone_app_image").hide();
    $("#GooglePay_phone_to_phone_app_image").hide(); 
    $("#paytmQrCode").hide();		
    $("#phonepeQrCode").hide();	
    $("#googlepayQrCode").hide();	
	
    actOnclickedString($("#id_payment_status_0").val())
	 
  $("#id_payment_status_0").click(function(){
    actOnclickedString($("#id_payment_status_0").val())				
  });
  $("#id_payment_status_1").click(function(){
    actOnclickedString($("#id_payment_status_1").val())		
  });  
  $("#id_payment_status_2").click(function(){
    actOnclickedString($("#id_payment_status_2").val())				
  });  
  $("#id_payment_status_3").click(function(){	
    actOnclickedString($("#id_payment_status_3").val())				
  });
  $("#id_payment_status_4").click(function(){
    actOnclickedString($("#id_payment_status_4").val())			
  });  

  $("#first_paytmQrCode").click(function(){
    $("#paytmreadme").hide();	
    $("#paytmQrCode").show();		
  });
  $("#first_paytmreadme").click(function(){
    $("#paytmQrCode").hide();		  
    $("#paytmreadme").show();		
  }); 
  
  $("#first_phonepeQrCode").click(function(){
    $("#phonepereadme").hide();	
    $("#phonepeQrCode").show();		
  });
  $("#first_phonepereadme").click(function(){
    $("#phonepeQrCode").hide();		  
    $("#phonepereadme").show();		
  });   
  
    $("#first_googlepayQrCode").click(function(){
    $("#googlepayreadme").hide();	
    $("#googlepayQrCode").show();		
  });
  $("#first_googlepayreadme").click(function(){
    $("#googlepayQrCode").hide();		  
    $("#googlepayreadme").show();		
  });
  
function actOnclickedString(recString) {
	if(recString  == "not-paid")
	{
        console.log("not-paid clicked")			
		$("#paytm_phone_to_phone_app_image").hide();	
		$("#phonePe_phone_to_phone_app_image").hide();
		$("#GooglePay_phone_to_phone_app_image").hide();		
	}else if(recString == "paid_cash")
	{
        console.log("paid_cash clicked")			
		$("#paytm_phone_to_phone_app_image").hide();	
		$("#phonePe_phone_to_phone_app_image").hide();
		$("#GooglePay_phone_to_phone_app_image").hide();		
	}else if(recString == "paid-by-payTm-phoneApp")
	{
        console.log("paid-by-payTm-phoneApp clicked")		
		$("#paytm_phone_to_phone_app_image").show();	
		$("#phonePe_phone_to_phone_app_image").hide();
		$("#GooglePay_phone_to_phone_app_image").hide();		
	}else if(recString == "paid-by-phonePe-phoneApp")
	{
        console.log("paid-by-phonePe-phoneApp clicked")		
		$("#phonePe_phone_to_phone_app_image").show();
		$("#paytm_phone_to_phone_app_image").hide();
		$("#GooglePay_phone_to_phone_app_image").hide();		
	}else if(recString == "paid-by-googlePay-phoneApp")
	{
        console.log("paid-by-googlePay-phoneApp clicked")		
		$("#GooglePay_phone_to_phone_app_image").show();	
		$("#phonePe_phone_to_phone_app_image").hide();
		$("#paytm_phone_to_phone_app_image").hide()		
	}else
	{
		console.log("no matching turning off all in phone-pay-app-picker");
		$("#paytm_phone_to_phone_app_image").hide();	
		$("#phonePe_phone_to_phone_app_image").hide();
		$("#GooglePay_phone_to_phone_app_image").hide();		
	}
}	
});


